import { AttachmentBlockSchema, } from './attachment-block/attachment-model.js';
import { BookmarkBlockSchema } from './bookmark-block/bookmark-model.js';
import { CodeBlockSchema, } from './code-block/code-model.js';
import { DataViewBlockSchema } from './data-view-block/data-view-model.js';
import { DatabaseBlockSchema } from './database-block/database-model.js';
import { DividerBlockSchema } from './divider-block/divider-model.js';
import { EmbedGithubBlockSpec } from './embed-github-block/index.js';
import { EmbedHtmlBlockSpec } from './embed-html-block/embed-html-spec.js';
import { FrameBlockSchema } from './frame-block/frame-model.js';
import { ImageBlockSchema } from './image-block/image-model.js';
import { ListBlockSchema } from './list-block/list-model.js';
import { NoteBlockSchema } from './note-block/note-model.js';
import { PageBlockSchema } from './page-block/page-model.js';
import { ParagraphBlockSchema } from './paragraph-block/paragraph-model.js';
import { SurfaceBlockSchema } from './surface-block/surface-model.js';
import { SurfaceRefBlockSchema } from './surface-ref-block/surface-ref-model.js';
/** Built-in first party block models built for affine */
export const AffineSchemas = [
    CodeBlockSchema,
    ParagraphBlockSchema,
    PageBlockSchema,
    ListBlockSchema,
    NoteBlockSchema,
    DividerBlockSchema,
    ImageBlockSchema,
    SurfaceBlockSchema,
    BookmarkBlockSchema,
    FrameBlockSchema,
    DatabaseBlockSchema,
    SurfaceRefBlockSchema,
];
export const __unstableSchemas = [
    DataViewBlockSchema,
    AttachmentBlockSchema,
    EmbedGithubBlockSpec.schema,
    EmbedHtmlBlockSpec.schema,
];
//# sourceMappingURL=models.js.map